import React, { Component } from 'react';
import { observer, PropTypes as MobxPropTypes } from 'mobx-react';
import PropTypes from 'prop-types';
import { Button, ButtonGroup, Card, CardBody } from 'reactstrap';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

import { modelOf } from '../../../prop-types';
import CustomerUser from '../../../models/CustomerUser';
import UserInfo from '../UserInfo';
import globalTranslations from '../../../i18n/globalTranslations';
import BalanceUser from '../../../models/BalanceUser';

@observer
export class UserList extends Component {
  render() {
    const { users, onRemoveClick, onEditClick, showBalance } = this.props;

    return (
      <div className="UserList">
        {users.map((user) => (
          <Card className="UserList__item" key={user.id} outline>
            <CardBody>
              <ButtonGroup className="UserList__item-buttons">
                <Button onClick={() => onEditClick(user.id)}>
                  <FormattedMessage {...globalTranslations.editTitle} />
                </Button>
                <Button
                  onClick={() =>
                    window.confirm(
                      this.props.intl.formatMessage(
                        globalTranslations.confirmRemoveTitle
                      )
                    ) && onRemoveClick(user.id)
                  }
                  color="danger"
                >
                  <FormattedMessage {...globalTranslations.removeTitle} />
                </Button>
              </ButtonGroup>
              <UserInfo user={user} showBalance={showBalance} />
            </CardBody>
          </Card>
        ))}
      </div>
    );
  }
}

UserList.propTypes = {
  users: PropTypes.oneOfType([
    MobxPropTypes.observableArrayOf(modelOf(CustomerUser)),
    MobxPropTypes.observableArrayOf(modelOf(BalanceUser)),
    PropTypes.arrayOf(modelOf(CustomerUser)),
    PropTypes.arrayOf(modelOf(BalanceUser))
  ]).isRequired,
  onRemoveClick: PropTypes.func.isRequired,
  onEditClick: PropTypes.func.isRequired,
  onPayment: PropTypes.func.isRequired,
  onQuantityUpdate: PropTypes.func,
  showBalance: PropTypes.bool,
  intl: intlShape.isRequired
};

export default injectIntl(UserList);



// WEBPACK FOOTER //
// ./src/components/user/UserList/index.jsx